'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const ContextComponent = require('../../../global/components/ContextComponent');
const SanitizeHtml = require('../../../global/components/SanitizeHtml');
const {trackAttributeClick} = require('../../actions/pdpTrackingActions');

class DetailsMaterialsAndTechniques extends ContextComponent {
    constructor(props) {
        super(props);
        this.fireTracking = this.fireTracking.bind(this);
    }

    fireTracking() {
        const label = this.props.gaLabel;
        this.context.executeAction(trackAttributeClick, {label});
    }

    render() {
        const contentsLength = this.props.contents.length - 1;
        const self = this;

        let detailItems = this.props.contents.map((content, index) => {
            const contentLength = content.length - 1;

            let materialsAndTechniquesItem = content.map((subContent, subIndex) => {
                let classes = subIndex < contentLength ? 'pdp-details-material-and-techniques-value' : '';

                if (subContent.isLink && subContent.link && !this.props.isPrintPage) {
                    return (
                        <a className={classes} href={subContent.link} onClick={self.fireTracking} key={subIndex}>
                            <SanitizeHtml content={subContent.value} />
                        </a>
                    );
                } else {
                    return <SanitizeHtml className={classes} key={subIndex} content={subContent.value} />;
                }
            });

            let delimiter = index < contentsLength ? ', ' : '';

            return (
                <div className="pdp-details-entry-content" key={index}>
                {materialsAndTechniquesItem}
                {delimiter}
                </div>
            );
        });

        return (
            <li className="pdp-details-entry">
                <div className="pdp-details-entry-title-container">
                    <span className="pdp-details-entry-title">{this.props.title}</span>
                </div>
                <div className="pdp-details-entry-content-container" data-tn={this.props.testName}>
                {detailItems}
                </div>
            </li>
        );
    }
}

DetailsMaterialsAndTechniques.defaultProps = {
    isPrintPage: false
};

DetailsMaterialsAndTechniques.propTypes = {
    contents: PropTypes.array.isRequired,
    gaLabel: PropTypes.string,
    testName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isPrintPage: PropTypes.bool
};

module.exports = DetailsMaterialsAndTechniques;



// WEBPACK FOOTER //
// ./assets/js/newPdp/details/components/DetailsMaterialsAndTechniques.jsx